
import { computed, defineComponent } from 'vue'
import Navbar from './components/Navbar/index.vue'
import Sidebar from './components/Sidebar/index.vue'
import AppMain from './components/AppMain.vue'
import { useStore } from '@/store'

export default defineComponent({
  name: 'Layout',
  components: {
    Navbar,
    Sidebar,
    AppMain
  },
  setup () {
    const store = useStore()
    const classObj = computed(() => {
      return {
        hideSidebar: !store.state.app.sidebar.opened,
        openSidebar: store.state.app.sidebar.opened,
        withoutAnimation: store.state.app.sidebar.withoutAnimation,
        mobile: store.state.app.device === 'mobile'
      }
    })
    return {
      classObj
    }
  }
})
